export const handleError = (axiosError) => {
  console.log('Raw Error', axiosError)
  const errors = ['Something went wrong']

  if (axiosError?.response?.status === 403) {
    return (window.location.href = '/forbidden')
  }

  if (axiosError?.response?.data) {
    if (axiosError?.response?.data?.errors) {
      return Object.values(axiosError?.response?.data?.errors)[0]
    }
    return axiosError?.response?.data?.detail ? [axiosError.response.data.detail] : errors
  }

  return errors
}

export const chunk = (array, size) => {
  const chunkedArr = []
  let index = 0
  while (index < array.length) {
    chunkedArr.push(array.slice(index, size + index))
    index += size
  }
  return chunkedArr
}
